import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults, palette } from '../../styles/utils';
import { rotate } from '../../styles/keyframes';
import { makeIconStyles } from '../../styles/fonts/iconfont';
import '../../styles/fonts/ionicons';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  get transition() {
    return theme.transition.small;
  },
  get disabledColor() {
    return theme.color.disabled;
  },
  get color() {
    return theme.color.lightBlack;
  },
  fontSize: {
    default: '16px',
    large: '22px',
    small: '14px',
    mini: '12px'
  }
};
var icon;
setDefault(function () {
  icon = deepDefaults(theme, {
    icon: defaults
  }).icon;
  makeStyles == null || makeStyles.clearCache();
});
export var colors = ['primary', 'warning', 'danger', 'success'];
export var sizes = ['large', 'small', 'mini'];
export var makeStyles = cache(function makeStyles(k, color) {
  // create the global icon styles
  makeIconStyles(k);
  return /*#__PURE__*/css("color:", icon.color, ";font-size:", icon.fontSize.default, ";line-height:1;font-weight:normal;", _mapInstanceProperty(sizes).call(sizes, function (size) {
    var fontSize = icon.fontSize[size];
    return /*#__PURE__*/css("&.", k, "-", size, "{font-size:", fontSize, ";}");
  }), " ", _mapInstanceProperty(colors).call(colors, function (color) {
    var _color = theme.color[color];
    return /*#__PURE__*/css("&.", k, "-", color, "{color:", _color, ";&.", k, "-hoverable:hover{color:", palette(_color, -2), ";}}");
  }), " &.", k, "-rotate:before{animation:", rotate, " 1s infinite linear;}&:before{font-size:inherit;}&.", k, "-hoverable{cursor:pointer;transition:color ", icon.transition, ";", color && /*#__PURE__*/css("&:hover{color:", palette(color, -2), "!important;}"), ";&:hover{color:", theme.color.primary, ";}}&.", k, "-disabled{cursor:not-allowed;color:", icon.disabledColor, "!important;}");
});